<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body" class="storeAccount-page">
        <el-date-picker v-model="dataMonth" type="month" value-format="yyyy-MM" @change="getDetails" :clearable="false" class="mt16 ml16"></el-date-picker>
        <div class="content-boxs">
          <div class="content-box">
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">项目名称</div>
              <div class="flex1 hbox">金额</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1">现金总收入</div>
              <div class="flex1">{{form.totalCashAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">电子会员应交款</div>
              <div class="flex1 hbox">{{form.shouldCollectAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1">
                <div class="align-item">
                  <div class="p5 otherWidth">营业收入</div>
                  <div class="bLeft w100b">
                    <div class="bBottom pl2 left hbox">修脚业绩</div>
                    <div class="bBottom pl2 left hbox">产品业绩</div>
                    <div class="bBottom pl2 left hbox">档案业绩</div>
                    <div class="bBottom pl2 left hbox">其他业绩</div>
                    <div class="pl2 left hbox">店面补助</div>
                  </div>
                </div>
              </div>
              <div class="flex1">
                <div class="bBottom hbox">{{form.footAchAmount}}</div>
                <div class="bBottom hbox">{{form.productAchAmount}}</div>
                <div class="bBottom hbox">{{form.repairAchAmount}}</div>
                <div class="bBottom hbox">{{form.otherAchAmount}}</div>
                <div class="hbox">{{form.shopSubsidyAmount}}</div>
              </div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">业绩总收入</div>
              <div class="flex1 hbox">{{form.totalAchievementAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1">
                <div class="align-item">
                  <div class="p5 textWriting">门店费用支出</div>
                  <div class="bLeft w100b">
                    <div class="bBottom pl2 left hbox">门店开支</div>
                    <div class="bBottom pl2 left hbox">门店管理费</div>
                    <div class="bBottom pl2 left hbox">短信服务费</div>
                    <div class="bBottom pl2 left hbox">工资小计</div>
                    <div class="bBottom pl2 left hbox">门店租金</div>
                    <div class="bBottom pl2 left hbox">住房租金</div>
                    <div class="bBottom pl2 left hbox">折旧金额</div>
                    <div class="bBottom pl2 left hbox">产品采购金额</div>
                    <div class="bBottom pl2 left hbox">品牌+媒体机费用</div>
                    <div class="bBottom pl2 left hbox">社保单位部分</div>
                    <div class="bBottom pl2 left hbox">预扣物业费</div>
                    <div class="bBottom pl2 left hbox">综合费用</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.depositPropertyManagementAmount">押金抵物业费</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.marketingAmount">美团营销费</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.transactionAmount">团购手续费</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.schoolAmount">学堂费用</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.livingAmount">生活费</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.playbillAmount">招聘海报费</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.excludingMaintenanceAmount">维修费剔除</div>
                    <div class="bBottom pl20 left hbox" v-if="comprehensiveFee.otherAmount">其他</div>
                    <div class="bBottom pl2 left hbox">手续费</div>
                    <div class="pl2 left hbox">合同签署费</div>
                  </div>
                </div>
              </div>
              <div class="flex1">
                <div class="bBottom hbox">{{form.shopSpendAmount}}</div>
                <div class="bBottom hbox">{{form.shopServiceAmount}}</div>
                <div class="bBottom hbox">{{form.smsServiceAmount}}</div>
                <div class="bBottom hbox">{{form.salaryAmount}}</div>
                <div class="bBottom hbox">{{form.shopAmount}}</div>
                <div class="bBottom hbox">{{form.houseAmount}}</div>
                <div class="bBottom hbox">{{form.depleteAmount}}</div>
                <div class="bBottom hbox">{{form.productPurchaseAmount}}</div>
                <div class="bBottom hbox">{{form.brandManageAmount}}</div>
                <div class="bBottom hbox">{{form.socialSecurityAmount}}</div>
                <div class="bBottom hbox">{{form.withholdingWaterAndElectricityAmount}}</div>
                <div class="bBottom hbox">{{form.otherExpendAmount}}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.depositPropertyManagementAmount">{{ comprehensiveFee.depositPropertyManagementAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.marketingAmount">{{ comprehensiveFee.marketingAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.transactionAmount">{{ comprehensiveFee.transactionAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.schoolAmount">{{ comprehensiveFee.schoolAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.livingAmount">{{ comprehensiveFee.livingAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.playbillAmount">{{ comprehensiveFee.playbillAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.excludingMaintenanceAmount">{{ comprehensiveFee.excludingMaintenanceAmount }}</div>
                <div class="bBottom hbox" v-if="comprehensiveFee.otherAmount">{{ comprehensiveFee.otherAmount }}</div>
                <div class="bBottom hbox">{{form.serviceFeeAmount}}</div>
                <div class="hbox">{{form.contractFeeAmount}}</div>
              </div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">门店费用支出小计</div>
              <div class="flex1 hbox">{{form.expendTotalAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">当月利润</div>
              <div class="flex1 hbox">{{form.profitAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">店长实发绩效奖金</div>
              <div class="flex1 hbox">{{form.actualShopManangerKpiAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">店员介绍费</div>
              <div class="flex1 hbox">{{form.actualStaffIntroduceAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">学员学费</div>
              <div class="flex1 hbox">{{form.actualStudentAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">代招费用</div>
              <div class="flex1 hbox">{{form.actualRecruitAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">店长介绍费</div>
              <div class="flex1 hbox">{{form.actualManagerRecommandAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">师带徒奖惩</div>
              <div class="flex1 hbox">{{form.teachAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">达标加餐</div>
              <div class="flex1 hbox">{{form.actualMealAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">目标利润</div>
              <div class="flex1 hbox">{{form.profitTargetAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">利润完成率(%)</div>
              <div class="flex1 hbox">{{form.profitCompleteRate}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">返店长补助后利润</div>
              <div class="flex1 hbox">{{form.actualShopManageSubsidyAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">弥补往月亏损金额</div>
              <div class="flex1 hbox">{{form.coverDeficitAmount}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">弥补亏后利润</div>
              <div class="flex1 hbox">{{form.coverDeficitProfit}}</div>
            </div>
            <div class="align-items bBottom">
              <div class="bRight flex1 hbox">店内分红</div>
              <div class="flex1 hbox">{{form.investmentDividend}}</div>
            </div>
            <div class="align-items">
              <div class="bRight flex1 hbox">门店投资分红</div>
              <div class="flex1 hbox">{{form.shopInvestmentDividend}}</div>
            </div>
          </div>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: {
    drawer,
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "门店收支账",
      form: {},
      dataMonth: '',
      comprehensiveFee: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //  页面初始化函数
    init() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data())
        // this.addEditShow = true;
        this.dataMonth = this.getLastMonth(new Date())
        this.getDetails();
        
      });
    },
    getDetails () {
      this.$api.get(this.$url.shopBill.get, {reportMonth: this.dataMonth}).then(res => {
        if (res) {
          this.form = res;
          this.addEditShow = true;
          this.comprehensiveFee = {}
          this.getShopBillImportFee()
        
        }
      });
    },
    getShopBillImportFee () {
      this.$api.get(this.$url.shopBillImportFee.get, {reportMonth: this.dataMonth}).then(res => {
        if (res) {
          this.comprehensiveFee = res;
        }
      });
    },
    back () {
      this.addEditShow = false;
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.storeAccount-page {
  .flex1 {
    flex: 1;
  }
  .content-boxs {
    padding: 16px;
    background: #fff;
    .hbox {
      height: 22px;
      line-height: 22px;
    }
    .content-box {
      text-align: center;
      border: 1px solid #333;
    }
    .otherWidth {
      width: 115px;
    }
    .textWriting {
      writing-mode: vertical-lr;
    }
    .bLeft {
      border-left: 1px solid #333;
    }
    .bRight {
      border-right: 1px solid #333;
    }
    .bBottom {
      border-bottom: 1px solid #333;
    }
    .pl2 {
      padding-left: 2px;
    }
    .left {
      text-align: left;
    }
  }
}
</style>